<template>
  <v-card flat>
    <v-row
      no-gutters
      class="px-4"
    >
      <v-col
        cols="12"
        class="px-3"
        :sm="12"
        :md="4"
      >
        <DateRangeSelector
          :from-label="dateMinLabel"
          :to-label="dateMaxLabel"
          :on-date-start-change-event="'onCreateAtFromChange'"
          :on-date-end-change-event="'onCreateAtToChange'"
          :clear-start-event="eventNames.ON_OFFER_CREATED_AT_FROM_CHANGE"
          :clear-end-event="eventNames.ON_OFFER_CREATED_AT_TO_CHANGE"
          @onCreateAtFromChange="onCreateAtFromChange"
          @onCreateAtToChange="onCreateAtToChange"
        />
      </v-col>
      <v-col
        v-if="!disableAssignmentType"
        cols="12"
        class="px-3"
        :sm="12"
        :md="4"
      >
        <WBDOfferTypeSelectorFilter
          :disabled="disableAssignmentType"
          :remote-selected-list-list="''"
          @onOfferTypeChange="onOfficeSelectorFilterChange"
        />
      </v-col>
      <v-col
        v-if="!hideWorkflow"
        cols="12"
        class="px-3"
        :sm="12"
        :md="4"
      >
        <WBDOfferWorkflowStateSelectorFilter
          :remote-value="''"
          @onOfferWorkflowStateStateChange="onOfferWorkflowStateStateChange"
        />
      </v-col>
      <v-col
        v-if="!hideOffice"
        cols="12"
        class="px-3"
        :sm="12"
        :md="4"
      >
        <WBDOfficeSelectorFilter
          :remote-list="[]"
          :label="'Объект'"
          :remote-selected-list-list="''"
          @onOfficeSelectorFilterChange="onOfficeSelectorFilterChange"
        />
      </v-col>
      <v-col
        v-if="!hidePublication"
        cols="12"
        class="px-3"
        :sm="12"
        :md="4"
      >
        <WBDOfferPublicationStatusSelectorFilter
          :remote-value="''"
          @onOfferPublicationStateChange="onOfferPublicationStateChange"
        />
      </v-col>

      <v-col
        cols="12"
        class="px-3"
        :sm="12"
        :md="4"
      >
        <WBDOrganizationSelectorFilter
          :remote-list="remoteList"
          :label="'организацию'"
          :selected-option-value="filteredOrgList"
          @onOrganizationListSelectorFilterChange="onOrganizationListSelectorFilterChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="12"
        :md="4"
      >
        <WBDCitySelectorFilter
          :filtered-laborer-list="''"
          :remote-list="[]"
          @onCitySelectorFilterChange="onCitySelectorFilterChange"
        />
      </v-col>
      <v-col
        v-if="!hideCoverage"
        cols="12"
        class="px-3"
        :sm="12"
        :md="4"
      >
        <NumberRangeSelector
          :min="0"
          :max="100"
          :label="'Диапазон Закрытости'"
          :reset-event="eventNames.NUMBER_RANGE_FILTER_RESET"
          :on-change-event="'onNumberRangeSelectorChange'"
          @onNumberRangeSelectorChange="onNumberRangeSelectorChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="12"
        :md="4"
      >
        <WBSearchQueryFilter
          :remote-value="''"
          :label="'Поиск по номеру или задания'"
          @onSearchQueryFilterChange="onSearchQueryFilterChange"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

import WBDOrganizationSelectorFilter from '@/components/common/filter/organization-selector-filter'
import WBDOfferTypeSelectorFilter from '@/components/common/filter/offer-type-filter'
import WBDOfficeSelectorFilter from '@/components/common/filter/office-selector-filter'
import WBDOfferPublicationStatusSelectorFilter from '@/components/common/filter/offer-publication-status-filter'
import DateRangeSelector from '@/components/common/filter/date-range-selector'
import WBSearchQueryFilter from '@/components/common/filter/search-query-filter'
import NumberRangeSelector from '@/components/common/filter/base-number-range'
import WBDOfferWorkflowStateSelectorFilter from '@/components/common/filter/offer-workflow-state-filter'
import WBDCitySelectorFilter from '@/components/common/filter/city-search-filter'

export default {
  name: 'WBDOfferListPageFilter',
  components: {
    WBDCitySelectorFilter,
    WBSearchQueryFilter,
    WBDOfferWorkflowStateSelectorFilter,
    WBDOrganizationSelectorFilter,
    WBDOfferPublicationStatusSelectorFilter,
    DateRangeSelector,
    NumberRangeSelector,
    WBDOfferTypeSelectorFilter,
    WBDOfficeSelectorFilter,
  },
  props: {
    hideOffice: Boolean,
    hidePublication: Boolean,
    hideWorkflow: Boolean,
    hideCoverage: Boolean,
    disableAssignmentType: Boolean,
    dateMinLabel: {
      type: String,
      default: 'Начала С'
    },
    dateMaxLabel: {
      type: String,
      default: 'Начала ПО'
    },
    offerListFilterSet: {
      type: Object,
      default: () => ({
        dateFrom: null,
        workflowStage: null,
        dateTo: null,
        office: null,
        executorGroupType: null,
        published: null,
        type: null,
        searchQuery: null,
        locality: null,
        profession: null,
        coverageMin: null,
        coverageMax: null,
      })
    }
  },
  data: () => ({
    searchQuery: '',
    filteredOrgList: '',
    remoteList: [],
    loading: true,
  }),
  computed: {
  },
  watch: {
    offerListFilterSet: {
      handler (val) {
        for (const [key, value] of Object.entries(val)) {
          if (this.offerListFilterSet[key] !== value) {
            this.offerListFilterSet[key] = value
          }
        }
      },
      deep: true,
    },
  },
  created () {
    this.eventsBus.$on(this.eventNames.OFFER_LIST_PAGE_FILTER_RESET, () => {
      this.resetAll()
      this.resetAll()
    })
  },
  methods: {
    onOrganizationListSelectorFilterChange (data) {
      this.offerListFilterSet.organization = data
    },
    onOfferWorkflowStateStateChange (data) {
      this.offerListFilterSet.workflowState = data
    },
    onOfficeSelectorFilterChange (data) {
      this.offerListFilterSet.office = data
    },
    onOfferTypeChange (data) {
      this.offerListFilterSet.executorGroupType = data
    },
    onSearchQueryFilterChange (data) {
      this.offerListFilterSet.searchQuery = data
    },
    onOfferPublicationStateChange (data) {
      this.offerListFilterSet.published = data
    },
    onCreateAtFromChange (data) {
      this.offerListFilterSet.dateFrom = data
    },
    onCreateAtToChange (data) {
      this.offerListFilterSet.dateTo = data
    },
    onNumberRangeSelectorChange (data) {
      if (!data || !Array.isArray(data)) {
        this.offerListFilterSet.coverageMin = null
        this.offerListFilterSet.coverageMax = null
      }
      this.offerListFilterSet.coverageMin = data[0]
      this.offerListFilterSet.coverageMax = data[1]
    },
    onCitySelectorFilterChange (data) {
      this.offerListFilterSet.locality = data
    },
    resetAll () {
      // dateFrom: null,
      //     dateTo: null,
      //     published: null,
      //     profession: null,

      this.eventsBus.$emit(this.eventNames.ORG_LIST_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.OFFICE_LIST_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.SEARCH_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.OFFER_PUBLICATION_STATUS_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.OFFER_TYPE_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.SEARCH_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.CITY_SEARCH_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.OFFER_WORKFLOW_STAGE_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.NUMBER_RANGE_FILTER_RESET)
    },
  }
}
</script>

